import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../services/api-service.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit {
  idRol: number | null = null;
  tipo_documento: string = '';
  codigo_documento: string = '';
  clave: string = '';
  id_rol: number = 0;
  nombre_rol: string = ''; // Nueva variable para el nombre del rol
  icono_rol: string = ''; // Nueva variable para el icono del rol

  private rolesMap: { [key: number]: { name: string; icon: string } } = {
    1: { name: 'Administrador', icon: 'fas fa-user-shield' },
    2: { name: 'Especialista en Documentación', icon: 'fas fa-file-alt' },
    3: { name: 'Especialista en Evaluaciones', icon: 'fas fa-clipboard-check' },
    4: { name: 'Estudiante', icon: 'fas fa-user-graduate' },
    5: { name: 'Institución Educativa', icon: 'fas fa-school' },
  };

  constructor(
    private authService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.idRol = params['id_rol'] ? +params['id_rol'] : null;
      if (this.idRol && this.rolesMap[this.idRol]) {
        this.nombre_rol = this.rolesMap[this.idRol].name; // Asignar el nombre del rol
        this.icono_rol = this.rolesMap[this.idRol].icon; // Asignar el icono del rol
      }
    });
  }

  onLoginSubmit() {
    if (this.codigo_documento && this.tipo_documento && this.clave) {
      // Usa el valor de idRol asignado desde los parámetros
      if (this.idRol === 5) {
        this.authService
          .loginInstitucion(this.codigo_documento, this.clave)
          .subscribe(
            (response) => {
              localStorage.removeItem('user');
              localStorage.removeItem('evaluacionEnProgreso');
              localStorage.removeItem('token');
              //Quitar token del response y almacenarlo en localStorage
              localStorage.setItem('token', response.token);
              delete response.token;
              localStorage.setItem('user', JSON.stringify(response));
              this.router.navigate(['/main-user']);
            },
            (error) => {
              //console.error('Error en login:', error);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.error.message || 'Error en login',
              });
              //alert('Error: ' + error.error.message);
            }
          );
      } else {
        //console.log(this.idRol);
        this.authService
          .login(
            this.tipo_documento,
            this.codigo_documento,
            this.clave,
            this.idRol!
          )
          .subscribe(
            (response) => {
              localStorage.removeItem('user');
              localStorage.removeItem('token');
              localStorage.removeItem('evaluacionEnProgreso');
              localStorage.setItem('token', response.token);
              delete response.token;
              localStorage.setItem('user', JSON.stringify(response));
              this.router.navigate(['/main']);
            },
            (error) => {
              //console.error('Error en login:', error);
              //alert('Error: ' + error.error.message);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.error.message || 'Error en login',
              });
            }
          );
      }
    } else {
      //alert('Por favor complete todos los campos');
      Swal.fire(
        'Advertencia',
        'Por favor complete todos los campos',
        'warning'
      );
    }
  }

  goBack(): void {
    this.location.back();
  }
}
